import { Box, BoxProps, Image, ImageProps } from '@chakra-ui/react';

export interface PictureProps extends BoxProps {
  sources: React.SourceHTMLAttributes<HTMLSourceElement>[];
  imgProps: ImageProps;
}

export const Picture: React.FC<PictureProps> = ({
  sources,
  imgProps,
  ...props
}) => (
  <Box as="picture" {...props}>
    {sources.map((source) => (
      <source {...source} key={source.srcSet} />
    ))}
    <Image {...imgProps} />
  </Box>
);
